import { Injectable } from '@angular/core';
import { parseCustom, formatCustom, isValidNumberCustom, asYouTypeCustom } from 'libphonenumber-js';
import * as metadata from './metadata.min.json';
import * as countrydata from './country-iso2-mapping.json';

export const parse = (...args) => parseCustom(...args, metadata);
export const format = (...args) => formatCustom(...args, metadata);
export const isValidNumber = (...args) => isValidNumberCustom(...args, metadata);

@Injectable()
export class CountryPhoneCodeDetails {
    countryPhoneCodes = [];
    constructor() {
        if (countrydata) {
            const rows = (<any>countrydata).country_iso2_code_to_countries;
            for (const row in rows) {
                if (rows.hasOwnProperty(row)) {
                    this.countryPhoneCodes.push({ alpha2Code: row, countryName: rows[row][0], phoneCode: rows[row][1] });
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/phone-numbers/phone-number.service.ts